import React from "react";
import "src/styles/common.css";

const Layout = ({ children }) => {
	return <main>{children}</main>;
};

export default Layout;
